
import { defineComponent } from 'vue';
import { getLoanInfo } from '@/api/loan';
import { LoanDetailsData } from '@/interfaces/loan';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CurrencyFormatLong from '@/filters/CurrencyFormatLong';
import ProductInfoDialog from './LoanDetailsProductInfoDialog.vue';
import PurchaseWindowInfoDialog from './LoanDetailsPurchaseWindowInfoDialog.vue';
import BorrowerAgreementLink from '@/components/Loans/BorrowerAgreementLink.vue';

export default defineComponent({
  name: 'LoanDetails',

  components: {
    BorrowerAgreementLink,
    ProductInfoDialog,
    PurchaseWindowInfoDialog,
    CustomButton,
  },

  data: () => ({
    loadingPage: false,
    showPurchaseWindowInfoDialog: false,
    showProductInfoDialog: false,
  }),

  computed: {
    activeLoanNumber(): string {
      return this.$store.getters['User/activeLoanNumber'];
    },
    hasBorrowerAgreement(): boolean {
      return !!this.loanDetails?.borrower_agreement_pdf_exists
        && !this.loanDetails?.purchase_window_closed_flag;
    },

    loanDetails(): LoanDetailsData {
      return this.$store.getters['Loan/getLoanData'];
    },
  },

  async mounted() {
    this.loadingPage = true;
    const loanNumber = this.activeLoanNumber;
    try {
      const { data } = await getLoanInfo(loanNumber);
      this.loanDetails = data;
    } finally {
      this.loadingPage = false;
    }
  },

  methods: {
    CurrencyFormatLong,
  }
});
